import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.css";
import DashBoard from "./pages/DashBoard";
import Layout from "./components/shared/Layout";
import Landing from "./pages/Landing";
import LoginPage from "./pages/LoginPage";
import Redirect from "./pages/Redirect";
import AllCampaign from "./pages/AllCampaign";
import CampaignCreation from "./pages/CampaignCreation"
import CreateCampaign from "./pages/CreateCampaign";

// Lazy-loaded components
const PercentageContribution = React.lazy(() =>
  import("./pages/PercentageContribution")
);
const Campaign = React.lazy(() => import("./pages/Campaign"));
const DoctorFlowChart = React.lazy(() => import("./pages/DoctorFlowChart"));
const RepFlowChart = React.lazy(() => import("./pages/RepFlowChart"));
const ProductFlowChart = React.lazy(() => import("./pages/ProductFlowChart"));
const ProductFlowChartDoctorWise = React.lazy(() => import("./pages/ProductFlowChartDoctor"));
const ProductFlowChartLocationWise = React.lazy(() => import("./pages/ProductFlowChartLocation"));
const RepWiseProductFlowChart = React.lazy(() => import("./pages/RepWiseProductFlowChart"));
const UserHierarchy = React.lazy(() => import("./pages/UserHierarchy"));

const ChemistFlowChart = React.lazy(() => import("./pages/ChemistFlowChart"));
const AdvancedAnalytics = React.lazy(() => import("./pages/AdvancedAnalytics"));
const DocRepMapping = React.lazy(() => import("./pages/DoctorRepMapping"));
const CreateUser = React.lazy(() => import("./pages/CreateUser"));
const Doctor = React.lazy(() => import("./pages/Doctor"));
const Products = React.lazy(() => import("./pages/Products"));
const Representatives = React.lazy(() => import("./pages/Representatives"));
const MonthlyReport = React.lazy(() => import("./pages/MonthlyReport"));
const ProductMapping = React.lazy(() => import("./pages/ProductMapping"));
const Analytics = React.lazy(() => import("./pages/Analytics"));
const FileUploadDetails = React.lazy(() => import("./pages/FileUploadDetails"));
const MappingFileUploadDetails = React.lazy(() =>
  import("./pages/MappingFileUploadDetails")
);
const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/home", element: <Landing />, index: true },
      { path: "/dashboard", element: <DashBoard /> },
      { path: "/products", element: <Products /> },
      { path: "/productmapping", element: <ProductMapping /> },
      { path: "/doctor", element: <Doctor /> },
      { path: "/fileuploaddetails", element: <FileUploadDetails /> },
      { path: "/representatives", element: <Representatives /> },
      { path: "/analytics", element: <Analytics /> },
      { path: "/advancedanalytics", element: <AdvancedAnalytics /> },
      { path: "/monthlyreport", element: <MonthlyReport /> },
      {
        path: "/mappingfileuploaddetails",
        element: <MappingFileUploadDetails />,
      },
      { path: "/createuser", element: <CreateUser /> },
      { path: "/userhierarchy", element: <UserHierarchy /> },
      { path: "/docrepmapping", element: <DocRepMapping /> },
      { path: "/doctorflowchart", element: <DoctorFlowChart /> },
      { path: "/doctor-wise-flowchart", element: <ProductFlowChartDoctorWise /> },
      { path: "/location-wise-flowchart", element: <ProductFlowChartLocationWise /> },
      { path: "/chemistflowchart", element: <ChemistFlowChart /> },
      {path: "/repflowchart", element: <RepFlowChart />} ,
      { path: "/productflowchart", element: <ProductFlowChart /> },
      { path: "/rep-product-flowchart", element: <RepWiseProductFlowChart /> },
      // { path: "/campaign", element: <Campaign /> },
      { path: "/allcampaign", element: <AllCampaign /> },
      { path: "/percentcontribution", element: <PercentageContribution /> },
      { path: "/campaigncreation", element: <CampaignCreation /> },
      { path: "/createcampaign", element: <CreateCampaign /> },
    ],
  },
  {
    path: "/redirect",
    element: <Redirect />,
  },
]);

export default function App() {
  return (
    <React.Suspense
      fallback={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      }
    >
      <RouterProvider router={router} />
    </React.Suspense>
  );
}
